// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetEventListPagingResultModel from '../../model/widget-event-list-paging-result-model';
import WidgetEventListPagingResultDTO from '../dto/widget-event-list-paging-result-dto';
import dtoSchema from '../schemas/widget-event-list-paging-result-schema';
import WidgetEventListModel from '../../model/widget-event-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class WidgetEventListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetEventListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WidgetEventListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: WidgetEventListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<WidgetEventListPagingResultDTO>): WidgetEventListPagingResultModel;
  static toModel(dto: DeepPartial<WidgetEventListPagingResultDTO> | undefined | null): WidgetEventListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<WidgetEventListPagingResultDTO> | undefined | null): WidgetEventListPagingResultModel | undefined {
    return dto ? new WidgetEventListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetEventListPagingResultModel> | WidgetEventListPagingResultModel): WidgetEventListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as WidgetEventListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetEventListPagingResultModel, can not map to WidgetEventListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
